export default "__VITE_ASSET__CGBv37jS__"